import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { IModuleVM } from '../../../infrastructure/components/module-vm';
import { Unsubscribe } from 'router5/dist/types/base';
import { IRouter } from '../../../infrastructure/router';
import { RouteParams, Routes } from '../../../routes-table';
import { RADIX_PARAM } from '../../../constants/common.constants';

export enum AttributesTab {
    EventLevelAttributes,
}

export class ManageAttributesVM implements IModuleVM {
    @mobx.observable
    private activeTab: AttributesTab = AttributesTab.EventLevelAttributes;
    @mobx.observable
    private subscriptions: Unsubscribe[] = [];

    constructor(@IoC.Inject private readonly routingService: IRouter<RouteParams> = IoC.Container.get(IRouter)) {}

    public didMount(): void {
        this.initRouterSubscriptions();
    }
    public willUnmount(): void {
        this.resetRouterSubscriptions();
    }

    @mobx.action.bound
    public setActiveTab(tab: AttributesTab): void {
        this.activeTab = tab;
    }

    public getActiveTab(): AttributesTab {
        return this.activeTab;
    }

    public getAccountId(): number {
        return parseInt(this.routeParams.accountId, RADIX_PARAM);
    }

    private get routeParams(): { accountId: string } {
        return this.routingService.router.getState().params;
    }

    @mobx.action.bound
    private initRouterSubscriptions(): void {
        this.subscriptions = [];

        this.subscriptions.push(this.routingService.listen(Routes.ManageEventAttributes, () => {
            this.setActiveTab(AttributesTab.EventLevelAttributes);
        }));
    }

    private resetRouterSubscriptions(): void {
        this.subscriptions.forEach(x => x());
        this.subscriptions = [];
    }

}
